var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 9C17.25 9.45 16.9499 9.75 16.4998 9.75H8.9977C8.54757 9.75 8.24749 9.45 8.24749 9V1.5C8.24749 1.05 8.54757 0.75 8.9977 0.75C13.574 0.75 17.25 4.425 17.25 9ZM16.5748 12.225C15.2995 15.375 12.2236 17.25 8.99769 17.25C7.9474 17.25 6.82209 17.025 5.77179 16.575C1.57062 14.775 -0.379925 9.975 1.42058 5.775C2.24581 3.825 3.74623 2.25 5.69677 1.425C6.07188 1.275 6.522 1.425 6.67205 1.8C6.82209 2.175 6.67205 2.625 6.29694 2.775C4.7215 3.525 3.44614 4.8 2.77096 6.375C1.34556 9.825 2.921 13.8 6.37196 15.225C9.82293 16.65 13.799 15.075 15.2244 11.625C15.3745 11.25 15.8246 11.1 16.1997 11.25C16.5748 11.4 16.7249 11.85 16.5748 12.225ZM9.74791 2.325C12.8238 2.625 15.2995 5.1 15.6746 8.25H9.74791V2.325Z",
    fill: "#6E6B7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.91cb2248d63410ca6c568d12376e3297.svg";
export { ForwardRef as ReactComponent };